import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi.js';
export const ManagePricing = () => {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [saving,   setSaving]   = useState({});
  const [prices,   setPrices]   = useState({});
  const [success,  setSuccess]  = useState('');

  useEffect(() => {
    productAPI.list()
      .then(res => {
        const p = res.data || [];
        setProducts(p);
        const init = {};
        p.forEach(pr => { init[pr.id] = { price: pr.price, mrp: pr.mrp, stock_quantity: pr.stock_quantity }; });
        setPrices(init);
      })
      .catch(() => {
        const mock = [
          { id:1, name:'Fresh Cabbage',  price:74, mrp:90,  stock_quantity:45,  image:null },
          { id:2, name:'Organic Potato', price:32, mrp:40,  stock_quantity:120, image:null },
          { id:3, name:'Strawberry',     price:50, mrp:70,  stock_quantity:30,  image:null },
        ];
        setProducts(mock);
        const init = {};
        mock.forEach(p => { init[p.id] = { price: p.price, mrp: p.mrp, stock_quantity: p.stock_quantity }; });
        setPrices(init);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (id) => {
    setSaving(s => ({...s, [id]: true}));
    try {
      await productAPI.updatePrice(id, prices[id]);
      setSuccess(`Product #${id} updated!`);
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) { alert(err.message); }
    finally { setSaving(s => ({...s, [id]: false})); }
  };

  const upPrice = (id, key, val) => setPrices(p => ({ ...p, [id]: { ...p[id], [key]: val } }));

  if (loading) return <div className="sp-skeleton" style={{height:300,borderRadius:'var(--r-lg)'}} />;

  return (
    <div>
      {success && <div className="sp-success">{success}</div>}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))',gap:'1rem'}}>
        {products.map(p => (
          <div key={p.id} className="sp-card">
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:'1rem'}}>
              <div style={{width:52,height:52,background:'var(--s3)',borderRadius:'var(--r-sm)',overflow:'hidden',flexShrink:0}}>
                {p.image ? <img src={`https://atrmart.in/storage/${p.image}`} alt={p.name} style={{width:'100%',height:'100%',objectFit:'cover'}} /> : <div style={{width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.4rem'}}>🌿</div>}
              </div>
              <div>
                <div style={{fontSize:14,fontWeight:600,color:'var(--t1)'}}>{p.name}</div>
                <div style={{fontSize:11,color:'var(--t3)',marginTop:2}}>Category: {p.category}</div>
              </div>
              <div style={{marginLeft:'auto'}}>
                <span className={`sp-badge ${p.stock_quantity > 0 ? 'active' : 'cancelled'}`}>
                  {p.stock_quantity > 0 ? `${p.stock_quantity} in stock` : 'Out of stock'}
                </span>
              </div>
            </div>

            <div className="sp-input-row">
              <div className="sp-input-group">
                <label className="sp-label">SELLING PRICE (₹)</label>
                <input className="sp-input" type="number" value={prices[p.id]?.price || ''} onChange={e => upPrice(p.id,'price',e.target.value)} />
              </div>
              <div className="sp-input-group">
                <label className="sp-label">MRP (₹)</label>
                <input className="sp-input" type="number" value={prices[p.id]?.mrp || ''} onChange={e => upPrice(p.id,'mrp',e.target.value)} />
              </div>
            </div>
            <div className="sp-input-group">
              <label className="sp-label">STOCK QUANTITY</label>
              <input className="sp-input" type="number" value={prices[p.id]?.stock_quantity || ''} onChange={e => upPrice(p.id,'stock_quantity',e.target.value)} />
            </div>

            {prices[p.id]?.mrp > prices[p.id]?.price && (
              <div style={{background:'rgba(16,185,129,0.06)',borderRadius:'var(--r-sm)',padding:'0.5rem 0.75rem',fontSize:12,color:'var(--em-300)',marginBottom:'0.75rem'}}>
                Discount: {Math.round(((prices[p.id].mrp - prices[p.id].price)/prices[p.id].mrp)*100)}% off MRP
              </div>
            )}

            <div style={{display:'flex',gap:'0.5rem'}}>
              <button className="sp-btn-primary" style={{flex:1}} onClick={() => handleSave(p.id)} disabled={saving[p.id]}>
                {saving[p.id] ? 'Saving…' : 'Save Changes'}
              </button>
              <button className="sp-btn-danger" onClick={() => { if(window.confirm('Delete this product?')) productAPI.delete(p.id).then(() => setProducts(pr => pr.filter(x => x.id !== p.id))).catch(console.error); }}>
                Delete
              </button>
            </div>
          </div>
        ))}
        {products.length === 0 && <p style={{color:'var(--t3)',textAlign:'center',padding:'3rem',gridColumn:'1/-1'}}>No products yet. Add your first product!</p>}
      </div>
    </div>
  );
};

export default ManagePricing;